
import helpItem from '../../api/help'
import help from '../../api/help'
import helpImage from '../../api/help'

import {
  HE_CREATE,
  HE_GET,
  HE_UPDATE,
  HE_DELETE,
  HE_IT_CREATE,
  HE_IT_GET,
  HE_IT_UPDATE,
  HE_IT_DELETE,
  HE_IM_GET,
  TAB_LOADING,
  HE_ID_UPDATE,
  HE_IM_UPDATE,
  HE_SET
} from '../types'

export default {
  namespaced: true,
  state: {
    helpItems: [],
    helps:[],
    isLoading: false,
    active:"",
  },
  actions: {
    // 静的な採用ページ作成に必要な情報をpostする
    createHelp ({commit}, data) {
      console.debug('*** Start *** createHelp')
      commit(HE_CREATE, data)
      console.debug('*** End *** createHelp')
    },
    getHelp ({commit}) {
      console.debug('*** Start *** getHelp')
      commit(HE_GET)
      console.debug('*** End *** getHelp')
    },
    updateHelp ({commit},data){
      console.debug('*** Start *** updateHelp')
      commit(HE_UPDATE, data)
      console.debug('*** End *** updateHelp')
    },
    deleteHelp ({commit}, data) {
      console.debug('*** Start *** deleteHelp')
      commit(HE_DELETE, data)
      console.debug('*** End *** deleteHelp')
    },
    createHelpItem({commit}, data) {
      console.debug('*** Start *** createHelpItem')
      commit(HE_IT_CREATE, data)
      console.debug('*** End *** createHelpItem')
    },
    getHelpItem ({commit}) {
      console.debug('*** Start *** getHelpItem')
      commit(HE_IT_GET)
      console.debug('*** End *** getHelpItem')
    },
    updateHelpItem ({commit}, data){
      console.debug('*** Start *** updateHelpItem')
      commit(HE_IT_UPDATE, data)
      console.debug('*** End *** updateHelpItem')
    },
    deleteHelpItem ({commit}, data) {
      console.debug('*** Start *** deleteHelpItem')
      console.debug('data: ' + JSON.stringify(data))
      commit(HE_IT_DELETE, data)
      console.debug('*** End *** deleteHelpItem')
    },
    tabLoading ({commit}) {
      console.debug('*** Start *** tabLoading')
      commit(TAB_LOADING)
      console.debug('*** End *** tabLoading')
    },
    updateHelpId ({commit}, data){
      console.debug('*** Start *** updateHelpId')
      commit(HE_ID_UPDATE, data)
      console.debug('*** End *** updateHelpId')
    },
    updateHelpItemImage ({commit}, data){
      console.debug('*** Start *** updateHelpItemImage')
      commit(HE_IM_UPDATE, data)
      console.debug('*** End *** updateHelpItemImage')
    },
    setActive ({commit}, data){
      console.debug('*** Start *** setActive')
      commit(HE_SET, data)
      console.debug('*** End *** setActive')
    },
    getHelpImage ({commit}){
      console.debug('*** Start *** getHelpImage')
      commit(HE_IM_GET)
      console.debug('*** End *** getHelpImage')
    },
  },

  mutations: {

    [HE_CREATE] (state, data) {
      console.debug('*** Start *** HE_CREATE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('data: ' + JSON.stringify(data))
      //console.log(data.item)
      var jsonData = {
      }
      jsonData['question'] = data.data.question
      jsonData['answer'] = data.data.answer
      jsonData['sort_id']=Number(data.data.sort_id)
      jsonData['item_id']=data.data.item_id
      console.info('jsonData: ' + JSON.stringify(jsonData))
      //console.log('HE_IT_CREATE2: ' + )
      help.createHelp(jsonData)
        .then((d) => {
          console.debug('*** Start *** createHelp callback')
          console.debug('d: ' + JSON.stringify(d))
          state.helps.push(d.data)
          console.debug('*** End *** createHelp callback')
        })
        .catch((e) => {
          console.debug('*** Start *** createHelp error callback')
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
          console.debug('*** End *** createHelp error callback')
        })
      console.debug('*** End *** HE_CREATE')
    },

    [HE_GET] (state) {
      console.debug('*** Start *** HE_GET')
      console.debug('state: ' + JSON.stringify(state))
      //console.log(JSON.stringify(state))
      //state.isLoading = true
      help.getHelp()
        .then((d) => {
          console.debug('*** Start *** getHelp callback')
          console.debug('d: ' + JSON.stringify(d))
          state.isLoading = false
          state.helps = d.data
          console.debug('*** End *** getHelp callback')
        })
      console.debug('*** End *** HE_GET')
    },
    
    [HE_UPDATE](state, data){
      console.log('*** Start *** HE_UPDATE')
      // console.log('state: ' + JSON.stringify(state))
      console.log('data: ' + JSON.stringify(data))
      help.updateHelp(data)
    },

    [HE_DELETE] (state, data) {
      console.debug('*** Start *** HE_DELETE')
      console.debug('state: ' + JSON.stringify(state))
      console.log('data: ' + JSON.stringify(data))
      state.helpID = data.help_id
      help.deleteHelp(state.helpID)
      console.log("data:" + data.help_id)
      console.debug('*** End *** HE_DELETE')
    },

    [HE_IT_CREATE] (state, data) {
      console.debug('*** Start *** HE_IT_CREATE')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('data: ' + JSON.stringify(data))
      var jsonData = {
      }
      jsonData['item'] = data.data.item
      jsonData['description'] = data.data.description
      jsonData['sort_id']=Number(data.data.sort_id)+1
      jsonData['image'] = data.data.image.replace(/^.*,/, '')
      
      console.info('jsonData: ' + JSON.stringify(jsonData))

      //console.log('HE_IT_CREATE2: ' + )
      helpItem.createHelpItem(jsonData)
        .then((d) => {
          console.debug('*** Start *** createHelpItem callback')
          console.debug('d: ' + JSON.stringify(d))
          state.helpItems.push(d.data)
          console.debug('*** End *** createHelpItem callback')
        })
        .catch((e) => {
          console.debug('*** Start *** createHelpItem error callback')
          console.error('e: ' + JSON.stringify(e))
          alert('エラーが発生しました。')
          console.debug('*** End *** createHelpItem error callback')
        })
      console.debug('*** End *** HE_IT_CREATE')
    },

    [HE_IT_GET] (state) {
      console.debug('*** Start *** HE_IT_GET')
      console.debug('state: ' + JSON.stringify(state))
      //console.log(JSON.stringify(state))
      //state.isLoading = true
      helpItem.getHelpItem()
        .then((d) => {
          console.debug('*** Start *** getHelpItem callback')
          console.debug('d: ' + JSON.stringify(d))
          state.isLoading = false         
          state.helpItems = d.data
          console.debug('*** End *** getHelpItem callback')
        })
      console.debug('*** End *** HE_IT_GET')
    },

    [HE_IT_UPDATE](state, data){
      console.log('*** Start *** HE_IT_UPDATE')
      // console.log('state: ' + JSON.stringify(state))
      console.log('data: ' + JSON.stringify(data))
      
      helpItem.updateHelpItem(data)

    },

    [HE_IT_DELETE] (state, data) {
      console.debug('*** Start *** HE_IT_DELETE')
      console.debug('state: ' + JSON.stringify(state))
      console.log('data: ' + JSON.stringify(data))
      state.itemID = data.item_id
      helpItem.deleteHelpItem(state.itemID)
      console.log("data:" + data.item_id)
      console.debug('*** End *** HE_IT_DELETE')
    },

    [HE_IM_GET] (state) {
      console.debug('*** Start *** HE_IM_GET')
      console.debug('state: ' + JSON.stringify(state))
      //console.log(JSON.stringify(state))
      helpImage.getHelpImage()
        .then((d) => {
          console.debug('*** Start *** getHelpImage callback')
          console.debug('d: ' + JSON.stringify(d))
          state.helps = d.data
          console.debug('*** End *** getHelpImage callback')
        })
      console.debug('*** End *** HE_IM_GET')
    },

    [TAB_LOADING] (state) {
      console.debug('*** Start *** TAB_LOADING')
      console.debug('state: ' + JSON.stringify(state))
      state.helpItems = []
      state.helps = []
      state.isLoading = true
      console.debug('*** End *** TAB_LOADING')
    },

    [HE_ID_UPDATE](state, data){
        console.log('*** Start *** HE_ID_UPDATE')
        // console.log('state: ' + JSON.stringify(state))
        console.log('data: ' + JSON.stringify(data))
        helpItem.updateHelpId(data)
    },

    [HE_IM_UPDATE](state, data){
      console.log('*** Start *** HE_IM_UPDATE')
      // console.log('state: ' + JSON.stringify(state))
      console.log('data: ' + JSON.stringify(data))
      data.image = data.image.replace(/^.*,/, '')
      helpItem.updateHelpItemImage(data)
    },

    [HE_SET](state,data){
      console.log('*** Start *** HE_SET')
      state.active = data.active
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/help.js